import * as React from "react";
import type { SVGProps } from "react";

const SvgUserIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 23.413 21.111"
        {...props}
    >
        <path
            id="Icon"
            d="M18.654,17.84l.563.166a11.675,11.675,0,0,1,7.934,7.884l.354,1.221H4.092l.354-1.221a11.675,11.675,0,0,1,7.934-7.884l.563-.166L15.8,20.626Zm.544,2.183L15.8,23.34l-3.4-3.318a9.77,9.77,0,0,0-5.614,5.169H24.812A9.77,9.77,0,0,0,19.2,20.023ZM15.8,6a5.829,5.829,0,0,1,5.9,5.757,5.9,5.9,0,0,1-11.8,0A5.829,5.829,0,0,1,15.8,6Zm0,1.919a3.839,3.839,0,1,0,3.932,3.838A3.886,3.886,0,0,0,15.8,7.919Z"
            transform="translate(-4.092 -6)"
            fill="currentColor"
        />
    </svg>
);
export default SvgUserIcon;
